@if (options) {
  <div class="map__wrapper">
    @if (loading) {
      <div class="map-loader">
        <loader></loader>
      </div>
    }
    <ol-map
      (mapReady)="mapReady($event)"
      (zoomChange)="zoomChange($event)"
      [zoom]="options.zoom"
      [minZoom]="options.minZoom"
      [maxZoom]="options.maxZoom"
      [draggable]="options.draggable"
      [enableZoomControl]="options.enableZoomControl"
      >
      @if (type === 'polygons' && polygons) {
        <ol-data-layer
          [geoJson]="polygons"
          [styles]="mapService.polygonStyles"
          (layerClick)="mapService.layerClick($event, options.polygonType)"
        ></ol-data-layer>
      }
      @if (type === 'polygons' && polygonMarkers && polygonMarkers.length && polygons && polygons.features && polygonLayer == 'county') {
        @for (item of polygonMarkers; track item) {
          @if (item.labelOptions && item.labelOptions.text) {
            <ol-marker
              [latitude]="item.latitude"
              [longitude]="item.longitude"
              [label]="item.labelOptions"
            ></ol-marker>
          }
        }
      }
      @if (type === 'markers' && markers && markers.length) {
        <ol-clusters
          [markers]="markers"
          [styles]="options.clusterStyles || defaultMapOptions.clusterStyles"
          [iconUrl]="options.icon || defaultMapOptions.icon"
          >
          <ng-template let-marker="feature" let-close="close">
            @if (marker.schoolInfo || marker.FieldSchoolName || marker.FieldName) {
              <ol-info-window
                (close)="close()"
                >
                @if (marker.schoolInfo) {
                  <p class="title with--border">
                    {{ marker.schoolInfo.entityLabel }}
                  </p>
                  @if (!infoWindowFunding) {
                    @if (marker.schoolInfo.fieldRegistrationCode) {
                      <p>
                        {{ 'school.register_code' | translate }}:
                        <strong>{{ marker.schoolInfo.fieldRegistrationCode }}</strong>
                      </p>
                    }
                    @if (marker.schoolInfo.fieldOwnershipType) {
                      <p>
                        {{ 'school.ownership' | translate }}:
                        <strong
                          >{{ marker.schoolInfo.fieldOwnershipType
                          }}</strong
                          >
                        </p>
                      }
                    }
                    @if (!infoWindowFunding) {
                      <hr />
                      <p>
                        {{ 'school.select_investment_measure_year' | translate }}:
                      </p>
                      <div class="tab-buttons">
                        @for (item of mapService.groupYears(marker.schoolInfo.subsidies); track item) {
                          <button (click)="showFunding(item, infoWindow)" [attr.data-test-id]="'map-open-funding-button-' + item">
                            {{ item }}
                          </button>
                        }
                      </div>
                    }
                    @if (infoWindowFunding) {
                      <a
                        href="javascript:void(0);"
                        (click)="showFunding(false)"
                        class="link"
                        data-test-id="map-close-funding-link"
                        >&lt; {{ 'button.back' | translate }}</a
                        >
                        <div class="snazzy-scrollarea">
                          <p>
                            {{ infoWindowFunding }}-{{
                            'school.selected_year_investment_measure' | translate }}
                          </p>
                          @for (item of mapService.parseInfoWindowMarkerData(marker.schoolInfo.subsidies); track item) {
                            @if (item.year == infoWindowFunding) {
                              <p>
                                {{ 'school.investment_measure' | translate }}:
                                <strong>{{ item.investmentMeasure?.entityLabel }}</strong
                                  ><br />
                                  {{ 'school.investment_project' | translate }}:
                                  <strong>{{ item.investmentProject }}</strong><br />
                                  {{ 'school.investment_max_amount' | translate }}:
                                  <strong>{{ item.investmentAmount | currency:"EUR" }}</strong
                                    ><br />
                                    {{ 'school.investment_deadline' | translate }}:
                                    <strong
                                      >{{ item.investmentDeadline |
                                      date:"dd.MM.yyyy" }}</strong
                                      >
                                    </p>
                                  }
                                }
                              </div>
                            }
                          }
                          @if (marker.FieldSchoolName) {
                            <p class="title with--border">{{ marker.FieldSchoolName }}</p>
                            @if (marker.FieldAddress) {
                              <p>
                                {{ 'school.map_address' | translate }}:
                                <strong>
                                  <a
                                    [href]="'https://google.com/maps/place/' + (marker.Lat || marker.lat) + ',' + (marker.Lon || marker.lon)"
                                    rel="nofollow noopener"
                                    target="_blank"
                                    [attr.data-test-id]="'map-school-coordinates-link-' + (marker.Lat || marker.lat) + ',' + (marker.Lon || marker.lon)"
                                  >{{ marker.FieldAddress }}</a>
                                </strong>
                              </p>
                            }
                            @if (marker.FieldEducationalInstitutionTy) {
                              <p>
                                {{ 'school.institution_type' | translate }}:
                                <strong>{{ marker.FieldEducationalInstitutionTy }}</strong>
                              </p>
                            }
                            @if (marker.FieldSchoolContactPhone || marker.FieldSchoolContactEmail) {
                              <p
                                >
                                {{ 'school.contact_info' | translate }}:
                                @if (marker.FieldSchoolContactPhone) {
                                  <a
                                    href="tel:{{ marker.FieldSchoolContactPhone }}"
                                    [attr.data-test-id]="'map-school-phone-' + marker.FieldSchoolContactPhone"
                                    >{{ marker.FieldSchoolContactPhone }}</a
                                    >
                                    }@if (marker.FieldSchoolContactPhone && marker.FieldSchoolContactEmail) {
                                    <span
                                      >, </span
                                      >
                                    }
                                    @if (marker.FieldSchoolContactEmail) {
                                      <a
                                        href="mailto:{{ marker.FieldSchoolContactEmail }}"
                                        [attr.data-test-id]="'map-school-email-' + marker.FieldSchoolContactEmail"
                                        ><strong>{{ marker.FieldSchoolContactEmail }}</strong></a
                                        >
                                      }
                                    </p>
                                  }
                                  @if (marker.FieldSchoolWebpageAddress) {
                                    <p
                                      style="margin-bottom: 20px"
                                      >
                                      {{ 'school.website' | translate }}:
                                      <a
                                        href="{{ marker.FieldSchoolWebpageAddress | url }}"
                                        target="_blank"
                                        rel="noopener"
                                        [attr.data-test-id]="'map-school-webpage-' + (marker.FieldSchoolWebpageAddress | removeProtocol | slugify)"
                                        ><strong
                                        >{{ marker.FieldSchoolWebpageAddress | removeProtocol }}</strong
                                        ></a
                                        >
                                      </p>
                                    }
                                    <a [routerLink]="marker.EntityPath" class="button" [attr.data-test-id]="'map-school-view-more-link-' + (marker?.EntityPath | slugify)"
                                      >{{ 'button.view_more' | translate }}</a
                                      >
                                    }
                                    @if (marker.FieldJobTime) {
                                      <p class="title with--border">{{ marker.FieldName }}</p>
                                      @if (marker.FieldJobTime) {
                                        <p>
                                          @for (timeStr of marker.FieldJobTime; track timeStr; let isLast = $last) {
                                            <strong>{{ timeStr | translate }}</strong
                                              >@if (!isLast) {
                                              <span>, </span>
                                            }
                                          }
                                        </p>
                                      }
                                      @if (marker.FieldOfferedBy) {
                                        <p class="no-margin">
                                          {{ 'jobOffer.offered_by' | translate }}:
                                          <strong>{{ marker.FieldOfferedBy }}</strong>
                                        </p>
                                      }
                                      @if (marker.FieldAddress) {
                                        <p class="no-margin">
                                          {{ 'event.aadress' | translate }}:
                                          <strong>
                                            <a
                                              [href]="'https://google.com/maps/place/' + (marker.Lat || marker.lat) + ',' + (marker.Lon || marker.lon)"
                                              rel="nofollow noopener"
                                              target="_blank"
                                              [attr.data-test-id]="'map-job-coordinates-link-' + (marker.Lat || marker.lat) + ',' + (marker.Lon || marker.lon)"
                                            >{{ marker.FieldAddress }}</a>
                                          </strong>
                                        </p>
                                      }
                                      @if (marker.FieldDate) {
                                        <p class="no-margin end-item">
                                          {{ 'jobOffer.job_expiry' | translate }}:
                                          <strong>{{ marker.FieldDate * 1000 | date:"dd.MM.yyyy" }}</strong>
                                        </p>
                                      }
                                      <a
                                        href="{{ marker.FieldURL | url }}"
                                        target="_blank"
                                        rel="noopener"
                                        class="button"
                                        [attr.data-test-id]="'map-job-url-link-' + (marker.FieldURL | removeProtocol | slugify)"
                                        >
                                        <icon glyph="external-link" size="medium"></icon>
                                        <span>{{ 'button.view_more' | translate }}</span>
                                      </a>
                                    }
                                  </ol-info-window>
                                }
                              </ng-template>
                            </ol-clusters>
                          }
                          @if (mapService.infoLayer && mapService.infoLayer.status && options.enablePolygonModal) {
                            <ol-overlay
                              [isOpen]="mapService.infoLayer.status"
                              [latitude]="mapService.infoLayer.latitude"
                              [longitude]="mapService.infoLayer.longitude"
                              (isOpenChange)="layerClickStatus($event)"
                              >
                              <ng-template let-close="close">
                                <ol-info-window (close)="close()">
                                  @if (mapService.infoLayer.title) {
                                    <p class="title">
                                      {{ mapService.infoLayer.title }}
                                    </p>
                                  }
                                  <p>{{ mapService.infoLayer.currency | currency }}</p>
                                </ol-info-window>
                              </ng-template>
                            </ol-overlay>
                          }
                        </ol-map>
                        @if (options.enableParameters && parameters && parameters.length) {
                          <div
                            class="map__additions"
                            >
                            @for (item of parameters; track item) {
                              <div class="pair">
                                <div class="pair__label">{{ item.label }}:</div>
                                <div class="pair__value">{{ item.value | shorten: 20: '...' }}</div>
                              </div>
                            }
                          </div>
                        }
                        @if (options.enableOuterLink) {
                          <a
                            class="outerLink"
                            href="http://www.google.com/maps/place/{{ options.centerLat }},{{ options.centerLng }}"
                            attr.aria-label="{{'button.map_closer' | translate}}"
                            target="_blank"
                            [attr.data-test-id]="'map-outer-link-' + options.centerLat + ',' + options.centerLng"
                            >
                            <icon glyph="external-link" size="medium"></icon>
                            <span>{{'button.map_closer' | translate}}</span>
                          </a>
                        }
                        @if (type === 'polygons' && polygons && options.enableLayerSelection) {
                          <div
                            class="polygons__toggle"
                            >
                            <button
                              (click)="changeLayer('county')"
                              [class.active]="polygonLayer === 'county'"
                              data-test-id="map-enable-county-layer-button"
                              >
                              {{ 'school.counties' | translate }}
                            </button>
                            <button
                              (click)="changeLayer('kov')"
                              [class.active]="polygonLayer === 'kov'"
                              data-test-id="map-enable-municipalities-layer-button"
                              >
                              {{ 'school.municipalities_detailed' | translate }}
                            </button>
                          </div>
                        }
                      </div>
                      @if (options.enablePolygonLegend && heatmap && heatmap.length > 0 && type === 'polygons' && options.polygonType === 'investment') {
                        <div
                          class="map__legend"
                          >
                          @for (item of heatmap; track item; let first = $first; let last = $last) {
                            <div
                              class="map__legend__block"
                              >
                              <div
                                class="map__legend__color"
                                [style.background-color]="item.color"
                              ></div>
                              @if (options.polygonType === 'investment') {
                                <div
                                  class="map__legend__item"
                                  >
                                  {{ item.minAmount | legendCurrency:"min" }} - {{ item.maxAmount |
                                  legendCurrency:"max" }} €
                                </div>
                              }
                              @if (options.polygonType === 'oskaFields') {
                                <div
                                  class="map__legend__item"
                                  >
                                  {{ item.minAmount | legendCurrency:"min" }} - {{ item.maxAmount |
                                  legendCurrency:"max" }}
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (options.enablePolygonLegend && heatmap && heatmap.length > 0 && type === 'polygons' && options.polygonType === 'oskaFields') {
                        <div class="mapLegend">
                          @for (item of heatmap; track item) {
                            @if ((params && params.mapIndicator && mapService.fieldMaxRanges[params.mapIndicator] && item.amount <= mapService.fieldMaxRanges[params.mapIndicator])
                              || (paramValue && mapService.fieldMaxRanges[paramValue] && item.amount <= mapService.fieldMaxRanges[paramValue])) {
                              <div
                                class="mapLegend__block"
                                >
                                <div
                                  class="mapLegend__color"
                                  [style.background-color]="item.color"
                                ></div>
                              </div>
                            }
                          }
                        </div>
                        @if (legendLabels && activeLegendParameters) {
                          <div
                            class="mapLegend__labels"
                            >
                            <div>{{ activeLegendParameters.start }}</div>
                            <div>{{ activeLegendParameters.end }}</div>
                          </div>
                        }
                      }
                    }
